export const isValidCpf = (value: string): boolean => {
  const cpf = value.replace(/\D/g, "")

  if (cpf.length !== 11) {
    return false
  }

  // Detects if all digits are the same (e.g., 111.111.111-11)
  if (/^(\d)\1{10}$/.test(cpf)) {
    return false
  }

  // First verifier digit
  let sum = 0

  for (let i = 0; i < 9; i++) {
    sum += Number(cpf[i]) * (10 - i)
  }

  let remainder = (sum * 10) % 11

  if (remainder === 10) {
    remainder = 0
  }

  if (remainder !== Number(cpf[9])) {
    return false
  }

  // Second verifier digit
  sum = 0

  for (let i = 0; i < 10; i++) {
    sum += Number(cpf[i]) * (11 - i)
  }

  remainder = (sum * 10) % 11

  if (remainder === 10) {
    remainder = 0
  }

  return remainder === Number(cpf[10])
}
